/**
 * The tile grid of one level (spec 03). The playfield is a grid of 8x8-pixel tiles, as in
 * the original: `true` is a solid block. Row 0 is the TOP row; columns run left to right.
 */
export interface TileGrid {
  readonly width: number;
  readonly height: number;
  /** Row-major, `width * height` entries. */
  readonly solid: readonly boolean[];
}

/** Parse rows of text ('#' solid, anything else empty). Every row must be the same width. */
export function gridFromRows(rows: readonly string[]): TileGrid {
  const width = rows[0]?.length ?? 0;
  const solid: boolean[] = [];
  rows.forEach((row, r) => {
    if (row.length !== width) throw new Error(`row ${r} is ${row.length} wide, expected ${width}`);
    for (const ch of row) solid.push(ch === '#');
  });
  return { width, height: rows.length, solid };
}

/** Solid test that treats everything outside the grid as empty. */
export function isSolid(grid: TileGrid, col: number, row: number): boolean {
  if (col < 0 || row < 0 || col >= grid.width || row >= grid.height) return false;
  return grid.solid[row * grid.width + col] === true;
}
